var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "arrival"
  }, [_c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.title)
    }
  }), _c('div', {
    staticClass: "lead-1 popup-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.subTitle)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.text)
    }
  }), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('seu-button', {
    attrs: {
      "label": _vm.popup.sections.main.fields.value.buttonLabel,
      "button-icon-before": _vm.share,
      "button-link": _vm.popup.sections.main.fields.value.buttonLink,
      "target": "_blank"
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }